import styled from 'styled-components';
import { getSpace, getColor, getGridSpans, maxContentWidth, mq } from '../../../stylesheets/tools';

const StyledExhibitionIntro = styled.div`
  position: relative;
  ${maxContentWidth('1440px')}
  width: 100%;
  margin: 0 auto ${getSpace('xxl')};
  background-color: ${getColor('black')};
  overflow: hidden;

  .exhibitionIntro__image {
    position: relative;
    width: 100%;
  }

  .exhibitionIntro__background {
    position: absolute;
    top: 66%;
    width: 1280px;
    height: auto;

    ${mq('xl')} {
      width: 1440px;
    }
  }

  .exhibitionIntro__image-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 80%;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .exhibitionIntro__text {
    position: relative;
    margin-top: ${getSpace('-40px')};

    ${mq('l')} {
      margin-top: ${getSpace('-150px')};
    }
  }

  .exhibitionIntro__headline {
    ${getGridSpans('width', { s: 12, m: 8, l: 6 })};
    ${getGridSpans('margin-left', { m: [1, 'full'], l: [2, 'full'] })};
  }

  .exhibitionIntro__copy {
    ${getGridSpans('width', { s: 11, m: 8, l: 6 })};
    ${getGridSpans('margin-left', { s: 1, m: [2, 'full'], l: [3, 'full'] })};
  }
`;

export default StyledExhibitionIntro;
